import { styled } from "@mui/material";

export const Offset = styled("div")(({ theme }) => theme.mixins.toolbar);
